import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import { Button, CardActionArea, CardActions } from '@mui/material'
import Fade from 'Components/Transitions/Fade'

export default function MultiActionAreaCard() {
  return (
    <Fade
      timeout={3000}
      sensorProps={{
        partialVisibility: true,
      }}>
      <Card sx={{ maxWidth: 345, height: '100%' }}>
        <CardActionArea>
          <CardMedia
            component='img'
            image='https://s3.us-west-2.amazonaws.com/www.tenspacesoftware.com/images/_e3edc412-cc6e-4acb-91c7-df8a2f143789.jpg'
            alt='Workin Robot'
          />
          <CardContent>
            <Typography gutterBottom variant='h5' component='div'>
              Adjunct Teams
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              We can supplement your development team with
              additional hands to get your project done faster, or
              help you greenfield new technology and upgrade your team's
              skills.
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button size='small' color='primary'>
            Learn More
          </Button>
        </CardActions>
      </Card>
    </Fade>
  )
}
